import borders from "../base/borders";
import boxShadows from "../base/boxShadows";
import colors from "../base/colors";
import typography from "../base/typography";

import pxToRem from "../functions/pxToRem";

const { lg } = boxShadows;
const { size } = typography;
const { text, white, light, dark, grey } = colors;
const { borderRadius } = borders;

const autocomplete = {
  styleOverrides: {
    popper: {
      boxShadow: lg,
      padding: pxToRem(8),
      fontSize: size.sm,
      color: text.main,
      backgroundColor: `${white.main} !important`,
      borderRadius: borderRadius.md,
    },
    paper: {
      boxShadow: "none",
      backgroundColor: "transparent",
    },
    listbox: {
      "::-webkit-scrollbar": {
        cursor: "pointer",
        width: "6px",
      },
      "::-webkit-scrollbar-thumb": {
        cursor: "pointer",
        borderRadius: pxToRem(10),
        backgroundColor: grey[300],
      },
    },

    option: {
      paddingTop: pxToRem(4),
      paddingBottom: pxToRem(4),
      paddingRight: pxToRem(12),
      paddingLeft: pxToRem(8),
      borderRadius: borderRadius.md,
      fontSize: size.sm,
      color: text.main,
      transition: "background-color 300ms ease, color 300ms ease",

      "&:hover, &:focus, &.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus":
        {
          backgroundColor: light.main,
          color: dark.main,
        },

      '&[aria-selected="true"]': {
        backgroundColor: `${light.main} !important`,
        color: `${dark.main} !important`,
      },
    },

    noOptions: {
      fontSize: size.sm,
      color: text.main,
    },

    groupLabel: {
      color: dark.main,
    },

    loading: {
      fontSize: size.sm,
      color: text.main,
    },

    tag: {
      display: "flex",
      alignItems: "center",
      height: "auto",
      padding: pxToRem(4),
      color: dark.main,

      "& .MuiChip-label": {
        lineHeight: 1.2,
        padding: `0 ${pxToRem(10)} 0 ${pxToRem(4)}`,
      },

      "& .MuiSvgIcon-root, & .MuiSvgIcon-root:hover, & .MuiSvgIcon-root:focus":
        {
          color: dark.main,
          marginRight: 0,
        },
    },
  },
};
export default autocomplete;
